export default __webpack_public_path__ + "static/media/aqua4.05eef42e.png";